
import React, { useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SidebarProvider } from "@/components/ui/sidebar";
import { useIsMobile } from "@/hooks/use-mobile";
import { usePageTitle } from "@/hooks/usePageTitle";
import AppSidebar from "./AppSidebar";
import PageHeader from "./PageHeader";
import SystemNotificationPopup from "@/components/notifications/SystemNotificationPopup";
import OnlineUsersStickyBar from "@/components/shared/OnlineUsersStickyBar";
import { useSessionGuard } from "@/hooks/useSessionGuard";

const DashboardLayout = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const pageTitle = usePageTitle();
  useSessionGuard();
  
  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
    
    // Add class to help with mobile navigation interactions
    if (isMobile) {
      document.body.classList.add('has-mobile-navigation');
    }
    
    return () => {
      document.body.classList.remove('has-mobile-navigation');
    };
  }, [isAuthenticated, navigate, isMobile]);

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <div className="flex-1 overflow-y-auto overflow-x-hidden min-w-0">
          <PageHeader pageTitle={pageTitle} />
          <div className={`${isMobile ? "p-3" : "p-6"}`}>
            <Outlet />
          </div>
        </div>
      </div>
      <SystemNotificationPopup />
      <OnlineUsersStickyBar />
    </SidebarProvider>
  );
};

export default DashboardLayout;
